import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
import QuestionList from "../views/QuestionList.vue";
import BookPost from "../views/BookPost.vue";
import QuestionDetail from "../views/QuestionDetail.vue";
import BookDetail from "../views/BookDetail.vue";
import BookList from "../views/BookList.vue";
import UserPage from "../views/UserPage.vue";
import Setting from "../views/Setting.vue";
import FindFriends from "../views/FindFriends.vue";
import About from "../views/About.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home
  },
  {
    path: "/question",
    name: "QuestionList",
    component: QuestionList
  },
  {
    path: "/bookpost",
    name: "BookPost",
    component: BookPost
  },
  {
    path: "/book",
    name: "BookList",
    component: BookList
  },
  {
    path: "/book/:bookId",
    name: "BookDetail",
    component: BookDetail
  },
  {
    path: "/question/:Qid",
    name: "QuestionDetail",
    component: QuestionDetail
  },
  {
    path: "/user/:userId",
    name: "UserPage",
    component: UserPage
  },
  {
    path: "/setting",
    name: "Setting",
    component: Setting
  },
  {
    path: "/findfriends",
    name: "FindFriends",
    component: FindFriends
  },
  {
    path: "/about",
    name: "About",
    component: About
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

export default router;
